import Vue       from 'vue'
// import VueHead   from 'vue-head'
import VueRouter from 'vue-router'
import WebFont   from 'webfontloader'

import { router } from './router'
import './modules/analytics'

import App from '../components/App.vue'

// Vue.use(VueHead)
Vue.use(VueRouter)

export const EventBus = new Vue()

export const Store = {
    isLoading: true,
    projects: null,
    single: null
}

const app = new Vue({
    router,
    components: { artofmyself: App },
}).$mount('artofmyself')



if( 'serviceWorker' in navigator ) {

    window.addEventListener('load', () => {

        navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {

            }, err => {
                console.log('Service Worker failed.', err)
            })

    })

}


WebFont.load({
    google: {
        families: ['Open Sans:300,700']
    }
})



// WEBPACK FOOTER //
// ./js/main.js